import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

function EditServiceProvider() {
  const navigate = useNavigate();
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              {/* <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/ServiceProviders")}
              /> */}
              Edit Service Provider
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            <div className="residentHeading">Service Provider Details</div>
            <div className="addAgencyMain">
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <div className="tabLeftDiv">
                    <div className="uploadImDiv">
                      <div className="uploadIm">
                        <img src="https://i0.wp.com/mytechoffer.com/wp-content/uploads/2022/05/09b1daaf2958e78a20be454394024869-asma.jpeg?resize=700%2C769&ssl=1" alt="altimg" />
                      </div>
                      <div className="uploadInpu">
                        <FileUploadIcon />
                        <span>Upload Profile Photo</span>
                        <input type="file" />
                      </div>
                    </div>
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">First Name</label>
                        <input className="inputSt" placeholder="First Name" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Last Name</label>
                        <input className="inputSt" placeholder="Last Name" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Phone Number</label>
                        <input className="inputSt" placeholder="Phone Number" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Service Type</label>
                        <input className="inputSt" placeholder="Service Type" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Age</label>
                        <input className="inputSt" placeholder="Age" />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <label className="tabsLabel">Qualification</label>
                        <input
                          className="inputSt"
                          placeholder="Qualification"
                        />
                      </Grid>

                      <Grid item xs={12} md={12}>
                        <label className="tabsLabel">Address</label>
                        <textarea
                          className="textAriaSt"
                          placeholder="Address"
                        ></textarea>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <div className="tabRightDiv">
                    <h4 className="documeUpload">Documents Upload</h4>
                    <div className="doqumentDiv1">
                      <span>Company Adhaar Card</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv2">
                      <span>Company PAN</span>
                      <div className="progresDoneOut">
                        <div className="progresDone"></div>
                        <CloseIcon />
                      </div>
                      <p>document1.jpg</p>
                    </div>
                    <div className="doqumentDiv1">
                      <span>Document 1</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv1">
                      <span>Document 2</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv1">
                      <span>Document 3</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                    <div className="doqumentDiv1">
                      <span>Document 4</span>
                      <FileUploadIcon />
                      <input type="file" />
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={12}>
                  <Button
                    className="addBt"
                    onClick={() => navigate("/DetailsViewOfServicePro")}
                  >
                    Add
                  </Button>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default EditServiceProvider;
